export default __webpack_public_path__ + "static/media/icon-chomei.7fbe94ad.svg";